export default {
  home: 'Home',
  myLoads: 'My loads',
  loadSteps: 'Load shipping steps',
  loadDetail: 'Load detail',
  allLoads: {
    assigned: 'Assigned loads',
    current: 'Current loads',
    discharged: 'Discharged loads'
  },
  dashboard: 'Dashboard',
  account: 'Account',
  editAccount: 'Edit account',
  loadOffers: 'Load offers',
  changePassword: 'Change password',
  createPassword: 'Create password',
  myBankAccounts: 'My bank accounts',
  addBankAccounts: 'Add bank accounts',
  activeSessions: 'Active sessions',
  loadDischarge: 'Load discharge',
  commercialBanking: 'Commercial banking',
  myPayments: 'My payments',
  wallet: 'Wallet',
  credentials: 'Credentials',
  contract: 'Contract'
}
